import { createContext } from 'react'

interface CardContextVale {
  open: boolean
  setOpen: (value: boolean) => void
  showExpandableHandler: boolean
}

export const CardContext = createContext<CardContextVale>({
  open: true,
  setOpen: () => ({}),
  showExpandableHandler: false
})
